import { Box, ButtonBase, Checkbox, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styles from './styles';
import moment from 'moment';

const Line = ({ label, value }) => (
  <Box display="flex" flex={1}>
    <Typography variant="caption" fontWeight="bold" flex={1} textAlign="start">
      {label}:
    </Typography>
    <Typography variant="caption" flex={2} textAlign="start">
      {value || '-'}
    </Typography>
  </Box>
);

const Lotes = ({ itens = [], selected, handleSelect }) => {
  const navigate = useNavigate();

  return itens?.map((item, idx) => (
    <Box key={idx} display="flex" alignItems="center" mr={2}>
      <Checkbox
        size="small"
        disableRipple
        sx={styles?.checkBox}
        checked={selected?.some((s) => s?.id === item?.id)}
        onChange={() => handleSelect(item)}
      />
      <Paper sx={styles?.paper} elevation={1}>
        <ButtonBase
          sx={styles?.btnBase}
          onClick={() => navigate(`/app/Armazenagem/Detalhes/${item?.id}`)}
        >
          <Box display="flex" flexDirection="column" flex={1}>
            <Typography variant="body1" fontWeight="bold" textAlign="start">
              Lote {item?.documento || ''}
            </Typography>
            <Line
              label="Emissão"
              value={
                Boolean(item?.dtemissao) &&
                moment(item?.dtemissao)?.format('DD/MM/YYYY [às] HH:mm')
              }
            />
          </Box>
        </ButtonBase>
      </Paper>
    </Box>
  ));
};

export default Lotes;
